/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Contacts_BlurbInputs */

const en_settings_contacts_blurb = /** @type {(inputs: Settings_Contacts_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts are cached locally so the composer can search them instantly. Refresh to pull the latest from Google.`)
};

const he_settings_contacts_blurb = /** @type {(inputs: Settings_Contacts_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אנשי הקשר נשמרים מקומית כדי שהמחבר יוכל לחפש בהם מיידית. רענן כדי למשוך את העדכניים מגוגל.`)
};

/**
* | output |
* | --- |
* | "Contacts are cached locally so the composer can search them instantly. Refresh to pull the latest from Google." |
*
* @param {Settings_Contacts_BlurbInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_contacts_blurb = /** @type {((inputs?: Settings_Contacts_BlurbInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Contacts_BlurbInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_contacts_blurb(inputs)
	return he_settings_contacts_blurb(inputs)
});